import Row from '@components/Row';
import Text from '@components/Text';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    labelKey: string;
    value?: string;
}

function NutritionModalRow({ labelKey, value }:Props) {
    const { t } = useTranslation('item');
    if (!value) {
        return (<Fragment/>);
    }
    return (
        <Row fullWidth justify='space-between'>
            <Text size='lg'>{t(`nutrition.${labelKey}`)}</Text>
            <Text size='lg' fontWeight='bold'>{value}</Text>
        </Row>
    );
}

export default NutritionModalRow;
